<template>
    <div class="home-child-wrapper">
        <div class="advertise-wrapper" v-loading="detailShade">
            <div class="feed-type-title">
                <span>广告详情</span>
            </div>
            <div class="feed-container">
                <div class="header-wrapper">
                    <AdHeader :advertise="feed" :scene="feedScene"/>
                </div>
                <div class="body-wrapper">
                    <div class="ad-media">
                        <ImgAdElement
                            v-if="feed.type === FEED_TYPES.IMAGE_AD"
                            :advertise="feed"
                            :scene="feedScene"
                        />
                        <VideoAdElement
                            v-if="feed.type === FEED_TYPES.VIDEO_AD"
                            :advertise="feed"
                            :scene="feedScene"
                        />
                    </div>
                    <div class="ad-content">
                        <div class="content-item flex">
                            <p class="item-title">公司名称：</p>
                            <p class="item-content">{{ feed.company }}</p>
                        </div>
                        <div class="content-item flex">
                            <p class="item-title">活动内容：</p>
                            <p class="item-content">{{ feed.content }}</p>
                        </div>
                        <div class="content-item flex">
                            <p class="item-title">联系人：</p>
                            <p class="item-content">{{ feed.contact }}</p>
                        </div>
                        <div class="content-item flex">
                            <p class="item-title">联系电话：</p>
                            <p class="item-content">{{ feed.mobile }}</p>
                        </div>
                        <div class="content-item flex">
                            <p class="item-title">公司地址：</p>
                            <p class="item-content">{{ feed.address }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { apiMap } from '../utils/apiMap';
import AdHeader from '../components/community/ad-header';
import ImgAdElement from '../components/community/feed-elements/image-ad-element';
import VideoAdElement from '../components/community/feed-elements/video-ad-element';
export default {
    name: 'ad-detail',
    data() {
        return {
            detailShade: true,
            feed: {
                userInfo: {
                    headImgUrl: ''
                }
            },
            feedScene: "feedDetail"
        }
    },
    components: {
        AdHeader,
        ImgAdElement,
        VideoAdElement,
    },
    computed: {
        
    },
    beforeMount() {
        console.log(this.$route.query)
        this.getAdvertisementDetail()
    },
    methods: {
        getAdvertisementDetail() {
            let _this = this;
            _this.$axios({
                    baseURL: apiMap['commonUrl'],
                    method: apiMap['advertiseDetail']['method'],
                    url: apiMap['advertiseDetail']['url'],
                    params: {
                        id: _this.$route.query.id,
                    },
                }).then(function (response) {
                    console.log(response.data.result.data);
                    if (response.data.result.statusCode==1) {
                       _this.feed = response.data.result.data;
                       _this.detailShade = false;
                    }else{

                    }
                    
                }).catch(function (error) {
                    console.log(error);
                });
        },
    }
}
</script>
<style scoped>
.feed-type-title {
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background-color: #1A70DB;
}

.advertise-wrapper {
    width: 840px;
    min-height: 200px;
    margin: 0 auto 20px;
}

.feed-container {
    padding: 15px;
    background-color: #fff;
}

.feed-title {
    max-width: 450px;
    line-height: 30px;
    font-weight: bold;
    font-size: 15px;
}

.ad-content {
    margin-top: 10px;
}

.content-item {
    margin: 0 0 10px 5px;
    line-height: 30px;
    font-size: 16px;
}

.item-title {
    width: 10%;
}

.item-content {
    width: 89%;
    margin-left: 5px;
}
</style>